














import { Component, Vue } from "vue-property-decorator";
import FlipCountdown from "@/components/FlipCountdown.vue";

@Component({
  components: {
    FlipCountdown,
  },
})
export default class NextChallengeCard extends Vue {}
